import React, { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthContext } from "./auth";


const PrivateRoute = ({ redirectPath = "/login" }) => {
  const { isAuth } = useContext(AuthContext);
  return isAuth ? <Outlet /> : <Navigate to={redirectPath} />;
};

export default PrivateRoute;
